import React, { useEffect, useRef } from "react";
import parse from "html-react-parser";
import Fade from "react-reveal/Fade";

const Resource = ({ title, subtitle, footnote, embed, widgetWorks, content }) => {
  // Create a ref for the iframe
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!widgetWorks) return;
    const script1 = document.createElement("script");
    script1.src = `https://calcs.widgetworks.com.au/s/${widgetWorks}/live.js`;
    script1.defer = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src = "https://calcs.widgetworks.com.au/widget/widget-scout.min.js";
    script2.defer = true;
    document.body.appendChild(script2);
  }, []);

  return (
    <section className='resource'>
      <div className='resource__inner'>
        <Fade bottom distance='40px'>
          <div className='resource__title'>
            {title && <h1>{parse(title)}</h1>}
            {subtitle && <h3>{subtitle}</h3>}
            {content && parse(content)}
          </div>
        </Fade>

        <Fade bottom distance='40px'>
          <div className='resource__embed'>
            <div className='iframe' ref={iframeRef}>
              {embed && !widgetWorks && parse(embed)}
              {widgetWorks &&
                <iframe
                  id={`wiwo-${widgetWorks}`}
                  src="about:blank"
                  width="100%"
                  height="200"
                  frameBorder="0"
                  data-wiwo-init="false"
                />
              }
            </div>
          </div>
        </Fade>

        {footnote && (
          <Fade bottom distance='40px'>
            <div className='resource__footnote'>{parse(footnote)}</div>
          </Fade>
        )}
      </div>
    </section>
  );
};

export default Resource;